export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL21lZGlhL2xpbmVfbG9nb19ob21lX3BhZ2UuNzQyMGFiMTYucG5nIjs="